import './header.scss';
import React, {useEffect, useRef, useState} from "react";
import T from "../../../shared/component/t/T";
import Storage from "../../../helpers/Storage";
import {Link, useNavigate} from "react-router-dom";
import Modal from "../../../shared/component/Modal/Modal";
import SigninModal from "../../Auth/signin/SigninModal";
import snippets from "../../../helpers/snippets";
import { default as _ } from '../../../helpers/Translate';
import {connect} from "react-redux";
import {withRouter} from "../../../helpers/withRouter";
import colors from "../../../assets/scss/variable/color.scss";
import gsap from 'gsap';

function Header(props) {
    const [device, setDevice] = useState(props.device)
    const [hospitalName] = useState(Storage.getHospitalName());
    const [language] = useState(props.language)
    const { direction, rightOrLeft } = Storage.directionGet() === "ltr" ? { direction: "ltr", rightOrLeft: "left" } : { direction: "rtl", rightOrLeft: "right" }

    let navigate = useNavigate();
    const [modalExit, setModalExit] = useState(false)
    const [dropdownAnotherLogin, setDropdownAnotherLogin] = useState(false)
    const anotherLoginRef = useRef()
    const [modalAnotherLogin, setModalAnotherLogin] = useState(false)

    let [isReport] = useState(props.page === "report")
    const [current, setCurrent] = useState(undefined)
    const [next, setNext] = useState(undefined)
    const [prev, setPrev] = useState(undefined)
    
    const [animation, setAnimation] = useState(null)
    const elementRef1 = useRef(null);
    const elementRef3 = useRef(null);
    const [animation2, setAnimation2] = useState(null)
    const elementRef2 = useRef(null);

    let [isSplitView] = useState(props.page === "split_viewer")
    const [fullScreen, setFullScreen] = useState(false)

    
    useEffect(()=> {
        if (elementRef1 && elementRef1.current && elementRef2 && elementRef2.current){
            const newAnimation = gsap?.fromTo(
              [elementRef1?.current, elementRef2?.current],
              { color: colors.primary },
              { duration: 0.5, color: colors.white, repeat: -1, yoyo: true, paused: true }
            );
            setAnimation(newAnimation)

            return () => {
                newAnimation.kill();
            };
        }
    },[elementRef1, elementRef2])
    
    useEffect(()=> {
        if (elementRef3 && elementRef3.current){
            const newAnimation2 = gsap?.fromTo(
              [elementRef3?.current],
              { color: colors.white },
              { duration: 0.5, color: colors.primary, repeat: -1, yoyo: true, paused: true }
            );
            setAnimation2(newAnimation2)
        
            return () => {
                newAnimation2.kill();
            };
        }
    },[elementRef3])

    useEffect(() => {
        function handleClickOutside(event) {
            if (anotherLoginRef.current && !anotherLoginRef.current.contains(event.target)) {
                setDropdownAnotherLogin(false);
            }
        }
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [anotherLoginRef]);

    useEffect(()=>{
        if (isReport || isSplitView){
            handleNext_Prev_Current()
        }
    },[isReport, isSplitView])

    useEffect(()=>{
        setDevice(props.device)
    },[props.device])

    useEffect(() => {
        setFullScreen(props.closeOrFullScreen?.state)
    }, [props.closeOrFullScreen]);
    
    const manualHover = (status) => {
        if (status){
            animation?.play?.();
            animation2?.play?.();
        } else {
            animation?.pause?.()
            animation2?.pause?.()
        }
    }

    const handleNext_Prev_Current = () => {
        let currentPatient = `${props.params.studyID}/${props.params.reportID}`
        setCurrent(currentPatient)
        if (!Storage.PatientsListCurrentIncluded(props.params.studyID, props.params.reportID)){
            setNext(null)
            setPrev(null)
        } else {
            if (!snippets.isObjectEmpty(Storage.PatientsListNext(currentPatient))) {
                setNext(Storage.PatientsListNext(currentPatient))
            }
            if (!snippets.isObjectEmpty(Storage.PatientsListPrev(currentPatient))) {
                setPrev(Storage.PatientsListPrev(currentPatient))
            }
            if (snippets.isObjectEmpty(Storage.PatientsListNext(currentPatient))) {
                setNext(null)
            }
            if (snippets.isObjectEmpty(Storage.PatientsListPrev(currentPatient))) {
                setPrev(null)
            }
        }
    }
    const nextPatient = () => {
        let localNext = next?.url;
        let currentURL = window.location.href
        window.location.href = currentURL.replace(current, localNext);
        window.location.reload();
    }
    const prevPatient = () => {
        let localPrev = prev?.url
        let currentURL = window.location.href
        window.location.href = currentURL.replace(current, localPrev);
        window.location.reload();
    }

    function HandleLogout() {
        Storage.removeStorageData();
        navigate("/signin");
    }

    function redirectHome() {
        navigate("/");
    }

    const closeAnotherLogin=()=>{
        setModalAnotherLogin(false)
    }

    const closeAnotherLoginSucceed=()=>{
        closeAnotherLogin()
        props?.afterLogin?.();
    }

    const closeExitSure = ()=>{
        setModalExit(false)
    }

    const nextPrevDiv = () => {
        return <>
            <div className={"reportCP_buttons_nextOrPrev"}>
            {next !== null && <div className={`reportCP_buttons_nextOrPrev_next`} onClick={nextPatient}
                                   title={_.init4("next_patient_name", {name: next?.name})}>
                <i className="fal fa-arrow-right" />
            </div>}
            {prev !== null && <div className={`reportCP_buttons_nextOrPrev_prev`} onClick={prevPatient}
                                   title={_.init4("prev_patient_name", {name: prev?.name})}>
                <i className="fal fa-arrow-left" />
            </div>}
        </div>
        </>
    }

    const closeFullScreenDiv = () => {
        return <>
            <div className={"reportCP_buttons_closeOrFullScreen"}>
                <div className={"reportCP_buttons_closeOrFullScreen_close"} onClick={splitCloseFunc} >
                    <i className="fal fa-close" />
                </div>
                <div className={"reportCP_buttons_closeOrFullScreen_fullScreen"} onClick={splitFullScreenFunc} >
                    {fullScreen ? <i className="fal fa-arrows-alt" /> : <i className="fal fa-compress-arrows-alt" />}
                </div>
            </div>
            {nextPrevDiv()}
        </>
    }

    const splitFullScreenFunc = () =>{
        props?.closeOrFullScreen?.fullFunc()
    }

    const splitCloseFunc = () =>{
        props?.closeOrFullScreen?.closeFunc()
    }

    return (
        <>
            <div className={'header'} style={{ direction: direction }}>
                <header className={'header__header'}>
                    <div className="header__header-container">

                        <div className={'header__info'}>
                            {(isReport && device !== "mobile") && nextPrevDiv()}
                            {(isSplitView && device !== "mobile") && closeFullScreenDiv()}
                        </div>

                        <div className={'header__info'}>
                            <div className={'info__organization'}>
                                <div className="info__container">
                                    <div className={'info__Hospital'}>
                                        <i className={'fal fa-hospital-alt'} />
                                        <span className={'info__text'} onClick={() => redirectHome()}
                                        >{hospitalName}</span>
                                    </div>
                                    <div className="seprator__line" />
                                    <div className={'info__section'}>
                                        <T token={"department"} /> {'\u00A0'}
                                        {Storage.getUserDepartmentTitle()}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={"header__info"}
                             onMouseEnter={()=> manualHover(true)}
                             onMouseLeave={()=> manualHover(false)}
                        >
                            {isReport &&
                                <Link className={"header__info__help__link"} to={"/help/report"} target="_blank" >
                                    <i className={'fal fa-bolt'} ref={elementRef1}/>
                                    <span ref={elementRef3}>
                                        <T token={"report_page_manual"} />
                                    </span>
                                    <i className={'fal fa-bolt'} ref={elementRef2}/>
                                </Link>
                            }
                            <div className={'username_logout'} >
                                <div className={'info__user'}
                                     onClick={() => setDropdownAnotherLogin(!dropdownAnotherLogin)}
                                     tabIndex={3}
                                     ref={anotherLoginRef}
                                >

                                    <div className={'info__value'}>
                                        {Storage.getUserDisplayName()}
                                        <div className={'info__logout'} >
                                            <i className={'fa fa-thin fa-power-off'} />
                                        </div>
                                    </div>
                                    {dropdownAnotherLogin && <div className={`login_as_another_user ${rightOrLeft}`} onMouseLeave={()=>setDropdownAnotherLogin(false)}>
                                        <div className={"dropdown__title"} onClick={() => setModalAnotherLogin(true)}>
                                            <i className={"fal fa-portal-enter"} />
                                            <T token={"login_as_another_user"} />
                                        </div>
                                        <div className={"dropdown__title"} onClick={() => setModalExit(true)}>
                                            <i className={"fal fa-power-off"} />
                                            <T token={"logout"} />
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>

                    </div>
                </header>

                <Modal show={modalExit}
                    closeModal={closeExitSure}
                    title='exit_sure'
                    closeable={true}
                >
                    <div className={'imodal__action'}>
                        <div className={'imodal__btn imodal__btn--primary'}
                            onClick={() => HandleLogout()}><T token={'exit_yes'} />
                        </div>
                        <div className={'imodal__btn imodal__btn--secondary'}
                            onClick={() => closeExitSure()}><T token={'exit_no'} />
                        </div>
                    </div>
                </Modal>
                {modalAnotherLogin && <SigninModal modalTitle={hospitalName} closeHandler={closeAnotherLogin} loginSucceed={closeAnotherLoginSucceed} closable={true}/>}
            </div>
        </>
    )
}


const mapStateToProps = state => {
    const language = state.LangReducer.language;
    const device = state.DeviceModeReducer.mode;
    return {language, device};
};

export default connect(mapStateToProps)(withRouter(Header));